import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { NgForm, FormGroup, FormControl, FormsModule } from '@angular/forms';
import { IRegistrationData } from '../../../shared/interfaces/IRegistrationData';
import { environment } from '../../../../environments/environment';
import { UserService } from '../../../user/user.service';
import { SessionService } from '../../../services/session.service';
import { Router } from '@angular/router';
import { DEFAULT_URL } from '../../../shared/static';
import { GuestService } from '../../../shared/services/guest.service';
import { AUTH_CONFIG } from '../../../auth/hubx-auth-variables';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgIf, NgClass } from '@angular/common';

export interface UserDataEmitter {
  isMobile: boolean;
  userData: IRegistrationData;
}

@Component({
    selector: 'app-guest-registration-mobile',
    templateUrl: './guest-registration-mobile.component.html',
    styleUrls: ['./guest-registration-mobile.component.scss'],
    standalone: true,
    imports: [NgIf, NgClass, FormsModule, BsDropdownModule]
})
export class GuestRegistrationMobileComponent implements OnInit, OnDestroy {
  phoneForm: FormGroup;
  showStepTwo = false;
  public showModalTrigger = false;
  public animateIn = false;
  public animateOut = false;
  public registrationFailed = false;
  public nextStep = false;
  public preRotation = false;
  public afterRotation = false;
  public isShowPassword = false;
  validFullName = false;
  guestRegisterMessage = environment.guestRegisterMessageX.message;
  categories: string[] = [];
  companyType: string[] = [];
  checkboxCheck = false;
  checkboxIsChecked = false;
  loading = false;
  checkboxAnimation = false;
  invalidFeedback = '';

  userData: IRegistrationData = {
    companyName: '',
    companyWeb: '',
    fullName: '',
    email: '',
    password: '',
    country: '',
    companyRevenue: '',
    phoneNumber: '',
    companyCategory: '',
    companyType: ''
  };

  @Output() registerDataEmitter = new EventEmitter<UserDataEmitter>();
  confirmEmail: boolean;

  constructor(
    private guestService: GuestService,
    private userService: UserService,
    private router: Router,
    private sessionService: SessionService) { }

  ngOnInit() {
    this.phoneForm = new FormGroup({
      phone: new FormControl()
    });
  }

  ngOnDestroy() {
  }

  cancelRegistration(): void {
    this.closeModal();
  }

  register(): void {
    this.registerDataEmitter.emit({ userData: this.userData, isMobile: true });
  }

  closeModal(): void {
    this.animateOut = true;
    this.animateIn = false;
    setTimeout(() => {
      this.showModalTrigger = false;
      this.animateOut = false;
    }, 400);
  }

  isFullName(): boolean {
    return this.userData.fullName.split(/\w+/g).length - 1 > 1;
  }

  showPassword(isShowPassword: boolean): void {
    this.isShowPassword = !isShowPassword;
  }

  createCategoriesRequest(): void {
    this.userData.companyCategory = '';

    if (!this.categories.length) {
      return;
    }

    for (let i = 0; i < this.categories.length; i++) {
      if (this.categories[i + 1] === this.categories[this.categories.length]) {
        this.userData.companyCategory += this.categories[i];
      } else {
        this.userData.companyCategory += this.categories[i] + ';';
      }
    }
  }

  createCompanyTypeRequest(): void {
    this.userData.companyType = '';
    if (!this.companyType.length) {
      return;
    }

    for (let i = 0; i < this.companyType.length; i++) {
      if (this.companyType[i + 1] === this.companyType[this.companyType.length]) {
        this.userData.companyType += this.companyType[i];
      } else {
        this.userData.companyType += this.companyType[i] + ';';
      }
    }
  }

  onSubmit(form: NgForm, step, $event): void {
    event.preventDefault();
    event.stopPropagation();
    this.loading = true;
    this.createCategoriesRequest();
    this.createCompanyTypeRequest();

    if (step === 1 && this.checkboxCheck) {
      // tslint:disable-next-line:max-line-length
      // ATTEMPT TO LOGIN AS BUYER/SUPER,VENDOR,ADMIN, OR SALES and if it doesn't work then may continue to next api call to check if email exists in guest list.
      this.guestService.getAllTypesEmail(this.userData.email).subscribe(
        (data) => {
          // THIS MEANS THE EMAIL EXISTS AND THE USER CANNOT CONTINUE WITH THIS EMAIL
          // alert('Error: Email already exists, please change it.');
          // but we check user and password to see if this is a returning customer
          this.loginAttempt(this.userData.email, this.userData.password);
        },
        (err) => {
          // THIS MEANS THE EMAIL IS UNIQUE AND DOES NOT EXIST ON THE SYSTEM AND THE USER MAY CONTINUE TO THE NEXT STEP
          this.invalidFeedback = '';
          this.nextStep = true;
          this.loading = false;
          return;
        }
      );
    } else if (step === 2) {
      this.register();
      this.loading = false;
    } else if (!this.checkboxCheck) {
      this.checkboxIsChecked = true;
      this.checkboxAnimation = true;
      this.loading = false;
      setTimeout(() => {
        this.checkboxAnimation = false;
      }, 1400);
      return;
    }

    this.loading = true;
    // console.log(this.userData);
  }

  emailConfirm(): boolean {
    // this.invalidFeedback = '';
    return this.userData.email.toLowerCase() !== this.userData.emailConfirm.toLowerCase();
  }

  checkFullName() {
    return true;
  }

  checkAccept(event: any) {
    if (event.target.checked) {
      this.checkboxCheck = true;
    } else {
      this.checkboxCheck = false;
    }
  }

  recordClick(event: any, category: string): void {
    if (event.target.checked) {
      this.categories.push(category);
    } else {
      this.categories = this.categories.filter(cate => cate !== category);
    }

    // (this.categories);
  }

  getCategoriesText(): string {
    if (this.categories.length === 1) {
      return this.categories[0];
    }
    if (this.categories.length > 1) {
      return this.categories[0] + '...';
    }
  }

  companyTypeClick(event: any, ctype: string): void {
    if (event.target.checked) {
      this.companyType.push(ctype);
    } else {
      this.companyType = this.companyType.filter(cate => cate !== ctype);
    }

    // console.log(this.companyType);
  }

  getCompanyTypeText(): string {
    if (this.companyType.length === 1) {
      return this.companyType[0];
    }
    if (this.companyType.length > 1) {
      return this.companyType[0] + '...';
    }
  }

  loginAttempt(email: string, password): void {
    sessionStorage.clear();
    localStorage.clear();

    // this.userService.auth.auth0.client.login({
    this.userService.auth.hubxAuth.login({
      realm: AUTH_CONFIG.realm,
      username: email,
      password: password
    }, (err, authResult) => {
      if (err) {
        this.loginGuest(email, password);
      } else {
        this.sessionService.isLoggedIn = 'true';
        // this.guestService.isLoggedIn = true;
        if (authResult && authResult.accessToken && authResult.idToken) {
          this.userService.auth.setSession(authResult);
          window.location.hash = '';
          this.userService.user_role = this.sessionService.userRole;

          switch (this.userService.user_role) {
            case 'BUYER': {
              this.userService.fetchUserInfo();
              break;
            }
            case 'SALES': {
              // this.userService.isGuest = false;
              this.sessionService.userEmail = email;
              this.userService.contactEmail = email,
                this.userService.auth.completedLoad = true;
              this.userService.sharedService.isLoggedInInternal = true;
              break;
            }
            case 'SUPER': {
              // this.userService.isGuest = false;
              this.sessionService.userEmail = email;
              this.userService.contactEmail = email,
                this.userService.auth.completedLoad = true;
              this.userService.sharedService.isLoggedInInternal = true;
              break;
            }
            case 'SELLER': {
              this.userService.fetchUserInfo();
              break;
            }
            case 'ADMIN': {
              // this.userService.isGuest = false;
              this.sessionService.companyName = email;
              this.userService.contactEmail = email,
                this.userService.foundBP = true;
              this.userService.topService.isDone = false;
              this.userService.auth.completedLoad = true;
              this.userService.sharedService.isLoggedInInternal = true;
              this.router.navigate(['/vendor/dashboard']);
              break;
            }
          }
        }
      }
    });
  }

  loginGuest(email: string, password: string): void {
    // this.userService.auth.auth0.client.login({
    this.userService.auth.hubxAuth.login({
      realm: environment.hubx_auth_guest_realm,
      username: email,
      password: password
    }, (err, authResult) => {
      if (err) {
        this.invalidFeedback = 'Error: Email already exists, please use another email.';
        this.loading = false;
        this.nextStep = false;
        this.userService.loading = false;
        this.userService.sharedService.isLoggedInGuest = false;
      } else {
        this.userService.auth.setSession(authResult);

        if (!this.userService.leadProfile.fullName) {
          this.guestService.getGuestEmailByEmail(email).subscribe(
            (data) => {
              this.userService.leadProfile = data;
            },
            (error) => {
              // console.log('error on login: ' + error);
            }
          );
        }

        this.sessionService.isLoggedIn = 'true';
        // this.guestService.isLoggedIn = true;
        window.location.hash = '';
        this.userService.user_role = this.sessionService.userRole;
        this.sessionService.userEmail = email;
        this.userService.contactEmail = email,
        this.userService.auth.completedLoad = true;
        this.userService.sharedService.isLoggedInGuest = true;
      }
    });
  }
}
